<template>
  <div class="voucher-list">
    <ul class="voucher-ul">
      <li v-for="voucherItem in voucherList" class="voucher-li">
        <div class="price">{{ $currencySymbol() }} {{ voucherItem.amount }} Off</div>
        <div class="type">{{ getVoucherType(voucherItem) }}</div>
        <div class="label">{{ voucherTips(voucherItem) }}</div>
        <div class="bottom-div">
          <div v-if="voucherItem.endDate && voucherItem.startDate" class="date">
            Valid:  {{ $tz.dateFormatEnFn(voucherItem.startDate, 2)}}-{{ $tz.dateFormatEnFn(voucherItem.endDate, 2) }}
          </div>
          <div class="btn-div">
            <button v-if="!voucherItem.isEarned" @click="postVoucherFn(voucherItem)">Claim Now</button>
            <button v-if="voucherItem.status === 1 && new Date(voucherItem.startDate) <= new Date()" class="use-now" @click="toUseFn(voucherItem)" >Use Now</button>
            <button v-if="voucherItem.status === 1 && new Date(voucherItem.startDate) > new Date()" class="use-now" @click="toUseFn(voucherItem)" >Starts Soon</button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { type Voucher, type ReceiveScene, postVoucher } from '@/api/models/userInfo'
import { showToast } from 'vant';

const props =  defineProps<{
  voucherList: Array<Voucher>
  receiveScene?: ReceiveScene
}>()

const emits = defineEmits<{
  (event: 'voucher:check'): void
}>()

const { $currencySymbol, $toThousandsFn } = useNuxtApp()
// 这里上传一下 AWS
const voucherBgMap: IAnyObject = {
  '1-1': { colorAttr: 'platform', label: 'Platform voucher' },
  '1-2': { colorAttr: 'compensate', label: 'Gift voucher' },
  '1-3': { colorAttr: 'shipping', label: 'Shipping voucher' },
  '2-1': { colorAttr: 'store', label: 'Store voucher' }
}
const getVoucherType = (item: Voucher) => {
    const key = `${item.ownerType}-${item.voucherType}`
    return voucherBgMap[key].label
}
const voucherTips = (item: Voucher) => {
  const { voucherType, usageScope, notice, limitType, isLimit, limitBillAmount, ownerType, storeName } = item

  if(voucherType === 3) {
    return notice
  }

  let _tips = ['Available']

  let limitText = ''
  
  if(!usageScope) {
    if(limitType === 2) {
      limitText = isLimit ? 'for specific products' : 'width specific products'
    } else {
      limitText = isLimit ? 'for all products' : 'with all products'
    }
  } else {
    limitText = isLimit ? `for ${usageScope}` : `with ${usageScope}`
  }

  if(isLimit) {
    _tips.push(`above ${$currencySymbol()} ${$toThousandsFn(limitBillAmount)}`, limitText)
  } else {
    _tips.push(limitText)
  }

  if (ownerType === 2 ) {
    // 指定店铺券
    _tips.push(`in ${storeName} store`)
  } else {
    if(ownerType === 1 && limitType === 1 && !isLimit) {
      // 平台券、全品类、无门槛
    _tips.push('in all stores')
    }
  }

  return _tips.join(' ')
}

const isGetNow = computed<boolean>(() => {
  const { status, isEarned, remainNumber } = props.item

  /** 
   * status： status: 1 未使用；2 已使用；3 已过期；4  已失效
   * 可领取数量 > 0, 并且为领取过 
   * */
  return (!status || status <= 0) && remainNumber > 0 && !isEarned
})

/** 领取优惠券 */
const postVoucherFn = async (item: Voucher) => {
  const params = {
    genId: item.genId,
    receiveScene: props.receiveScene
  }
  
  const res = await postVoucher(params, false)
  if(res && res.code === 0) {
    // 通知父组件刷新数据
    emits('voucher:check')
    showToast({
      message: 'Successfully collected.',
      zIndex: 3000
    })
  }
}

/** 点击用券 */
const toUseFn = (item: Voucher) => {
  if(!item.status) return
  if (item.ownerType === 1) {
    if(item.limiter?.categoryIds.length > 0){
      const ctgs = item.limiter.categoryIds.slice(0, 200).join('_')
      
      useRouter().push(`/search?backCid=${ctgs}&source=accountCenter|voucherCategory|${item.name}`)

    } else {
      useRouter().push('/')
    }
  } else {
    // 去店铺
    useRouter().push(`/store/${item.storeId}?source=accountCenter|voucherStore|${item.name}`)
  }
}
</script>

<style lang="scss" scoped>
.voucher-list {
  width: 100%;
  .voucher-ul {
    width: 100%;
    .voucher-li {
      margin: 20px;
      width: 860px;
      height: 280px;
      background: url('https://img.kilimall.com/c/h5/imgs/voucher-pc.png') no-repeat;
      background-size: 100% 100%;
      padding: 20px;
      position: relative;
      .price, .type {
        color: #E6712D;
        font-size: 28px;
        padding: 0 10px 10px 10px;
        font-weight: 800;
      }
      .price {
        font-size: 48px;
      }
      .label {
        padding: 10px;
        color: #333333;
        font-size: 28px;
        font-weight: 700;
        height: 50px;
        line-height: 40px;
        overflow: hidden;
      }
      .bottom-div {
        position: absolute;
        bottom: 3px;
        left: 0;
        padding: 10px 30px;
        width: 100%;
        display: flex;
        align-items: center;
        .date {
          width: 100px;
          flex: 1;
          color: #666666;
          font-size: 24px;
          overflow: hidden;
        }
        .btn-div {
          width: 160px;
          button {
            background-color: #E6712D;
            color: white;
            border-radius: 4px;
            overflow: hidden;
            font-weight: 700;
            font-size: 28px;
            width: 156px;
            height: 52px;
            border: 0;
            cursor: pointer;
          }
          .use-now {
            background-color: #999999;
          }
        }
      }

    }
  }
}
</style>
